<template>
  <div class="acceptance-tab">
    <div class="acceptance-tab__filters">
      <div class="acceptance-tab__filter-item">
        <CustomSelect
          :options="boolFilterOptions"
          label="Обязательно"
          option-label-key="label"
          option-value-key="value"
          @change="value => onFilterChange('is_default', value)"
          :value="filters.is_default"
        />
      </div>
      <div class="acceptance-tab__filter-item">
        <CustomSelect
          :options="boolFilterOptions"
          label="Активен"
          option-label-key="label"
          option-value-key="value"
          @change="value => onFilterChange('is_active', value)"
          :value="filters.is_active"
        />
      </div>
      <div class="acceptance-tab__filter-item acceptance-tab__filter-item--search">
        <CustomInput
          :value="filters.search_text"
          :isSearch="true"
          placeholder="Поиск по ID / названию / коду"
          class="acceptance-tab__search"
          v-debounce:300="onSearchChange"
        />
      </div>
    </div>

    <CustomTable
      title="Шаги приёмки"
      :rowsData="rows"
      :columns="stepsTableColumns"
      :stickyHeader="true"
      :loading="loading"
      :custom-body="true"
      :custom-header="true"
      :small="true"
    >
      <template #customHeader="props">
        <q-tr :props="props">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            <template v-if="col.name === 'actions'">
              <q-btn size="sm" title="Добавить" color="primary" dense round @click="openModal()" icon="add" />
            </template>
            <template v-else>{{ col.label }}</template>
          </q-th>
        </q-tr>
      </template>

      <template #customBody="props" v-if="!loading">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.acceptance_step_id }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.acceptance_step_name || '-' }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.acceptance_step_code || '-' }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <template v-if="props.row.description">
              <q-btn flat dense size="sm" color="primary" label="Посмотреть" no-caps @click="openDescriptionDialog(props.row.description)" />
            </template>
            <template v-else>-</template>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <q-icon :name="props.row.is_default ? 'check_circle' : 'cancel'"
                    :color="props.row.is_default ? 'positive' : 'grey'" size="20px" />
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <q-icon :name="props.row.is_active ? 'check_circle' : 'cancel'"
                    :color="props.row.is_active ? 'positive' : 'grey'" size="20px" />
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <div class="action-buttons">
              <q-btn @click="openModal(props.row)" color="primary-light" flat dense round size="sm" icon="edit">
                <q-tooltip>Редактировать</q-tooltip>
              </q-btn>
              <q-btn @click="confirmDelete(props.row)" color="negative" flat dense round size="sm" icon="delete"
                     :loading="!!deleteLoading[props.row.acceptance_step_id]">
                <q-tooltip>Удалить</q-tooltip>
              </q-btn>
            </div>
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>

    <q-dialog v-model="descriptionDialogShow">
      <q-card style="min-width: 400px; max-width: 600px;">
        <q-card-section class="acceptance-modal__header">
          <div class="acceptance-modal__title">Описание</div>
          <q-btn icon="close" flat round dense v-close-popup class="acceptance-modal__close" />
        </q-card-section>
        <q-card-section>
          <div style="white-space: pre-wrap;">{{ descriptionDialogText }}</div>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="modalShow" persistent>
      <q-card class="acceptance-modal">
        <q-card-section class="acceptance-modal__header">
          <div class="acceptance-modal__title">
            {{ editing ? 'Редактировать шаг приёмки' : 'Добавить шаг приёмки' }}
          </div>
          <q-btn icon="close" flat round dense v-close-popup class="acceptance-modal__close" />
        </q-card-section>

        <q-card-section class="acceptance-modal__content">
          <q-form @submit.prevent="save" class="acceptance-form">
            <div class="acceptance-form__section">
              <div class="acceptance-form__item">
                <q-input v-model="form.acceptance_step_name" label="Название шага" dense outlined :rules="[v => !!v || 'Обязательное поле']" />
              </div>
              <div class="acceptance-form__item">
                <q-input v-model="form.acceptance_step_code" label="Код шага" dense outlined :rules="[v => !!v || 'Обязательное поле']" />
              </div>
              <div class="acceptance-form__item">
                <q-input v-model="form.description" label="Описание" dense outlined />
              </div>
              <div class="acceptance-form__item">
                <q-toggle v-model="form.is_default" label="Обязательно" />
              </div>
              <div class="acceptance-form__item">
                <q-toggle v-model="form.is_active" label="Активен" />
              </div>
            </div>

            <div class="acceptance-modal__footer">
              <CustomButton @click="modalShow = false" :disabled="saving" outlined>Отмена</CustomButton>
              <CustomButton type="submit" :loading="saving"
                            :disabled="!form.acceptance_step_name || !form.acceptance_step_code">
                {{ editing ? 'Сохранить' : 'Создать' }}
              </CustomButton>
            </div>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="confirmDeleteDialog" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">Подтверждение удаления</div>
        </q-card-section>
        <q-card-section>Вы уверены, что хотите удалить эту запись?</q-card-section>
        <q-card-actions align="right">
          <q-btn flat label="Отмена" color="grey" @click="confirmDeleteDialog = false" />
          <q-btn unelevated label="Удалить" color="negative" @click="onDeleteConfirm" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";
import CustomButton from "@/components/common/CustomButton.vue";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import {
  getAcceptanceSteps,
  updAcceptanceStep,
  deleteAcceptanceStep,
  stepsTableColumns,
} from "@/views/Acceptance/services";

const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();

const boolFilterOptions = [
  { label: "Да", value: "1" },
  { label: "Нет", value: "0" },
];

const filters = ref({
  search_text: '',
  is_default: null,
  is_active: null,
});

const onFilterChange = (key, value) => {
  filters.value[key] = value || null;
  loadData();
};

const onSearchChange = (value) => {
  filters.value.search_text = value || '';
  loadData();
};

const rows = ref([]);
const loading = ref(false);
const modalShow = ref(false);
const editing = ref(null);
const saving = ref(false);
const deleteLoading = ref({});
const form = ref({
  acceptance_step_id: null,
  acceptance_step_name: "",
  acceptance_step_code: "",
  description: "",
  is_default: false,
  is_active: true,
});

const descriptionDialogShow = ref(false);
const descriptionDialogText = ref("");

const openDescriptionDialog = (text) => {
  descriptionDialogText.value = text;
  descriptionDialogShow.value = true;
};

const loadData = async () => {
  loading.value = true;
  const params = {};
  if (filters.value.search_text) params.search_text = filters.value.search_text;
  if (filters.value.is_default !== '' && filters.value.is_default != null) params.is_default = filters.value.is_default;
  if (filters.value.is_active !== '' && filters.value.is_active != null) params.is_active = filters.value.is_active;
  const res = await getAcceptanceSteps(params);
  loading.value = false;
  if (!res) return;
  rows.value = res || [];
};

const openModal = (row = null) => {
  editing.value = row;
  if (row) {
    form.value = {
      acceptance_step_id: row.acceptance_step_id,
      acceptance_step_name: row.acceptance_step_name,
      acceptance_step_code: row.acceptance_step_code,
      description: row.description || "",
      is_default: !!row.is_default,
      is_active: !!row.is_active,
    };
  } else {
    form.value = {
      acceptance_step_id: null,
      acceptance_step_name: "",
      acceptance_step_code: "",
      description: "",
      is_default: false,
      is_active: true,
    };
  }
  modalShow.value = true;
};

const save = async () => {
  if (!form.value.acceptance_step_name || !form.value.acceptance_step_code) {
    showErrorSnackbar("Название и код шага обязательны");
    return;
  }
  saving.value = true;
  const body = {
    acceptance_step_id: editing.value?.acceptance_step_id || null,
    acceptance_step_name: form.value.acceptance_step_name,
    acceptance_step_code: form.value.acceptance_step_code,
    description: form.value.description || null,
    is_default: form.value.is_default ? 1 : 0,
    is_active: form.value.is_active ? 1 : 0,
  };
  const res = await updAcceptanceStep(body);
  saving.value = false;
  if (!res) return;
  showSucceedSnackbar(editing.value ? "Шаг обновлён" : "Шаг добавлен");
  modalShow.value = false;
  await loadData();
};

const confirmDeleteDialog = ref(false);
const deleteTargetRow = ref(null);

const confirmDelete = (row) => {
  deleteTargetRow.value = row;
  confirmDeleteDialog.value = true;
};

const onDeleteConfirm = async () => {
  confirmDeleteDialog.value = false;
  if (!deleteTargetRow.value) return;
  const id = deleteTargetRow.value.acceptance_step_id;
  deleteLoading.value = { ...deleteLoading.value, [id]: true };
  const res = await deleteAcceptanceStep(id);
  deleteLoading.value = { ...deleteLoading.value, [id]: false };
  if (!res) return;
  showSucceedSnackbar("Шаг удалён");
  deleteTargetRow.value = null;
  await loadData();
};

onMounted(() => {
  loadData();
});
</script>

<style scoped lang="scss">
.acceptance-tab {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  padding-top: 12px;
}

.acceptance-tab__filters {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  flex-shrink: 0;
}

.acceptance-tab__filter-item {
  width: 200px;

  &--search {
    width: 280px;
  }
}

.acceptance-tab__search {
  margin-top: 22px;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

:deep(.custom-table) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

:deep(.custom-table__container) {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.acceptance-modal {
  min-width: 500px;
  max-width: 700px;
}

.acceptance-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.acceptance-modal__title {
  font-size: 20px;
  font-weight: 600;
  color: #373d48;
  line-height: 20px;
}

.acceptance-modal__close {
  color: #9ca3af;
}

.acceptance-modal__content {
  padding: 20px 24px;
}

.acceptance-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
}

.acceptance-form__section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.acceptance-form__item {
  width: 100%;
}

.acceptance-modal__footer {
  width: 100%;
  height: 46px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-top: 15px;
}

@media (max-width: 600px) {
  .acceptance-modal {
    min-width: 100%;
  }
}
</style>
